import React from 'react';
import { Chart } from 'react-google-charts';

export const ExplodedPieChart = ({ data }) => {
  const defaultData = [
    ['Category', 'Amount'],
    ['Development', 30],
    ['Marketing', 15],
    ['Investment', 20],
    ['Others', 35],
  ];

  const chartData = data && data.length > 0 ? data : defaultData;

  const options = {
    legend: 'none',
    pieSliceText: 'both',
    pieSliceTextStyle: {
      fontSize: 10,
      color: 'white',
      bold: true,
    },
    tooltip: { trigger: 'none' },
    slices: {
      0: { color: '#343C6A', offset: 0.1 },
      1: { color: '#FC7900', offset: 0.07 },
      2: { color: '#FA00FF', offset: 0.03 },
      3: { color: '#1814F3', offset: 0.0 },
    },
    pieSliceText: 'label',
    pieStartAngle: 0,
    is3D: false,
  };

  const formattedData = [
    ['Category', 'Amount', { role: 'annotation' }],
    ...chartData
      .slice(1)
      .map(([category, value]) => [
        category,
        value,
        `${category}\n${(
          (value / chartData.slice(1).reduce((sum, [_, val]) => sum + val, 0)) *
          100
        ).toFixed(0)}%`,
      ]),
  ];

  return (
    <div className="flex flex-col w-full bg-white rounded-lg shadow-sm" style={{ height: '250px' }}>
      <Chart
        chartType="PieChart"
        data={formattedData}
        options={options}
        width={'98%'}
        height={'98%'}
      />
    </div>
  );
};
